import {
  Route,
} from 'react-router';

import AdminOrderList from '#features/order/AdminList';
import AdminOrderDetail from '#features/order/AdminDetail';
import AdminInventoryOrderList from '#features/inventory/OrderList';
import AdminInventoryOrderDetail from '#features/inventory/InventoryDetail';
import AdminBulkList from '#features/order/BulkList';
import AdminBulkDetail from '#features/order/BulkDetail';
import InvoiceList from '#features/invoice/List';
import InvoiceDetail from '#features/invoice/Detail';
import InventoryReport from '#features/inventory/InventoryReport';
import InventorySalesReport from '#features/inventory/InventorySalesReport';
import SalespersonReport from '#features/order/SalespersonReport';
import CustomerReport from '#features/order/CustomerReport';
import CollectionList from '#features/collection/List';
import CollectionEdit from '#features/collection/Edit';
import TagList from '#features/tag/List';
import TagEdit from '#features/tag/Edit';
import ProductList from '#features/product/List';
import ProductEdit from '#features/product/Edit';
import VendorList from '#features/vendor/List';
import VendorEdit from '#features/vendor/Edit';
import UserList from '#features/user/List';
import UserEdit from '#features/user/Edit';
import UserDetail from '#features/user/Detail';
import ReceivingList from '#features/receiving/List';
import ReceivingEdit from '#features/receiving/Edit';
import UserOrderList from '#features/order/UserList';
import UserOrderDetail from '#features/order/UserDetail';
import OverdueOrders from '#features/order/OverdueOrders';
import Reminders from '#features/order/Reminders';
import UserShopLayout from '#features/shop/Layout';
import UserShopList from '#features/shop/List';
import UserShopProduct from '#features/shop/Product';
import UserCartList from '#features/cart/List';
import WebsiteInfo from '#features/website/Settings';
import WebsiteContent from '#features/website/Contents';
import { EnsureRoleRoute } from '#bootstrap/utils';
import { ADDONS, PRICE_MODEL, BILLING_CYCLE } from '#common/constants/addons';
import { USER_ROLES } from '#common/constants';
import AdminHome from './pages/AdminHome';
import WarehouseAnalyticsDashboard from './pages/WarehouseAnalyticsDashboard';
import AiReportsPage from './pages/AiReportsPage';
import InventoryAnalytics from '#features/inventory/InventoryAnalytics';

import icon from './assets/SWMBasic.jpg';

import type { Addon, AddonBootstrap } from '../types';

function apply(bootstrap: AddonBootstrap) {
  bootstrap.customer = bootstrap.customer.concat([
    <Route
      key="route-customer-order"
      path="order"
    >
      <Route
        index
        element={(
          <EnsureRoleRoute roles={[USER_ROLES.CUSTOMER]}>
            <UserOrderList />
          </EnsureRoleRoute>
        )}
      />
      <Route
        path="list"
        element={(
          <EnsureRoleRoute roles={[USER_ROLES.CUSTOMER]}>
            <UserOrderList />
          </EnsureRoleRoute>
        )}
      />
      <Route
        path="detail"
        element={(
          <EnsureRoleRoute roles={[USER_ROLES.CUSTOMER]}>
            <UserOrderDetail />
          </EnsureRoleRoute>
        )}
      />
    </Route>,

    <Route
      key="route-customer-invoice"
      path="invoices"
    >
      <Route
        index
        element={(
          <EnsureRoleRoute roles={USER_ROLES.CUSTOMER}>
            <InvoiceList />
          </EnsureRoleRoute>
        )}
      />
    </Route>,

    <Route
      key="route-customer-inventory"
      path="inventory"
    >
      <Route
        path="report"
        element={(
          <EnsureRoleRoute roles={[USER_ROLES.CUSTOMER]}>
            <InventoryReport />
          </EnsureRoleRoute>
        )}
      />
    </Route>,

    <Route
      key="route-customer-cart"
      path="cart"
    >
      <Route
        index
        element={(
          <EnsureRoleRoute roles={USER_ROLES.ALL_ROLES}>
            <UserCartList />
          </EnsureRoleRoute>
        )}
      />
      <Route
        path="list"
        element={(
          <EnsureRoleRoute roles={USER_ROLES.ALL_ROLES}>
            <UserCartList />
          </EnsureRoleRoute>
        )}
      />
    </Route>,

    <Route
      key="route-customer-shop"
      path="shop"
      element={<UserShopLayout />}
    >
      <Route
        index
        element={(
          <EnsureRoleRoute roles={USER_ROLES.ALL_ROLES}>
            <UserShopList />
          </EnsureRoleRoute>
        )}
      />
      <Route
        path="list"
        element={(
          <EnsureRoleRoute roles={USER_ROLES.ALL_ROLES}>
            <UserShopList />
          </EnsureRoleRoute>
        )}
      />
      <Route
        path="add"
        element={(
          <EnsureRoleRoute roles={USER_ROLES.ALL_ROLES}>
            <UserShopProduct />
          </EnsureRoleRoute>
        )}
      />
    </Route>,
  ]);

  bootstrap.admin = bootstrap.admin.concat([
    <Route
      key="route-admin-index"
      index
      element={(
        <EnsureRoleRoute roles={USER_ROLES.EXPCEPT_CUSTOMER}>
          <AdminHome />
        </EnsureRoleRoute>
      )}
    />,
    <Route
      key="route-admin-home"
      path="home"
      element={(
        <EnsureRoleRoute roles={USER_ROLES.EXPCEPT_CUSTOMER}>
          <AdminHome />
        </EnsureRoleRoute>
      )}
    />,

    <Route
      key="route-admin-order"
      path="order"
    >
      <Route
        index
        element={(
          <EnsureRoleRoute roles={USER_ROLES.EXPCEPT_CUSTOMER}>
            <AdminOrderList />
          </EnsureRoleRoute>
        )}
      />
      <Route
        path="list"
        element={(
          <EnsureRoleRoute roles={USER_ROLES.EXPCEPT_CUSTOMER}>
            <AdminOrderList />
          </EnsureRoleRoute>
        )}
      />
      <Route
        path="detail"
        element={(
          <EnsureRoleRoute roles={USER_ROLES.EXPCEPT_CUSTOMER}>
            <AdminOrderDetail />
          </EnsureRoleRoute>
        )}
      />
      <Route
        path="overdue"
        element={(
          <EnsureRoleRoute roles={USER_ROLES.EXPCEPT_CUSTOMER}>
            <OverdueOrders />
          </EnsureRoleRoute>
        )}
      />
      <Route
        path="reminders"
        element={(
          <EnsureRoleRoute roles={USER_ROLES.EXPCEPT_CUSTOMER}>
            <Reminders />
          </EnsureRoleRoute>
        )}
      />
    </Route>,

    <Route
      key="route-admin-bulk"
      path="bulk"
    >
      <Route
        index
        element={(
          <EnsureRoleRoute roles={USER_ROLES.ADMIN_AND_STUFF}>
            <AdminBulkList />
          </EnsureRoleRoute>
        )}
      />
      <Route
        path="list"
        element={(
          <EnsureRoleRoute roles={USER_ROLES.ADMIN_AND_STUFF}>
            <AdminBulkList />
          </EnsureRoleRoute>
        )}
      />
      <Route
        path="detail"
        element={(
          <EnsureRoleRoute roles={USER_ROLES.ADMIN_AND_STUFF}>
            <AdminBulkDetail />
          </EnsureRoleRoute>
        )}
      />
    </Route>,

    <Route
      key="route-admin-inventory"
      path="inventory"
    >
      <Route
        index
        element={(
          <EnsureRoleRoute roles={USER_ROLES.EXPCEPT_CUSTOMER}>
            <AdminInventoryOrderList />
          </EnsureRoleRoute>
        )}
      />
      <Route
        path="list"
        element={(
          <EnsureRoleRoute roles={USER_ROLES.EXPCEPT_CUSTOMER}>
            <AdminInventoryOrderList />
          </EnsureRoleRoute>
        )}
      />
      <Route
        path="detail"
        element={(
          <EnsureRoleRoute roles={USER_ROLES.EXPCEPT_CUSTOMER}>
            <AdminInventoryOrderDetail />
          </EnsureRoleRoute>
        )}
      />
      <Route
        path="report"
        element={(
          <EnsureRoleRoute roles={USER_ROLES.EXPCEPT_CUSTOMER}>
            <InventoryReport />
          </EnsureRoleRoute>
        )}
      />
      <Route
        path="sales"
        element={(
          <EnsureRoleRoute roles={USER_ROLES.EXPCEPT_CUSTOMER}>
            <InventorySalesReport />
          </EnsureRoleRoute>
        )}
      />
      <Route
        path="analytics"
        element={(
          <EnsureRoleRoute roles={USER_ROLES.ADMIN_ONLY}>
            <InventoryAnalytics />
          </EnsureRoleRoute>
        )}
      />
    </Route>,

    <Route
      key="route-admin-salesperson"
      path="salesperson"
    >
      <Route
        path="report"
        element={(
          <EnsureRoleRoute roles={USER_ROLES.EXPCEPT_CUSTOMER}>
            <SalespersonReport />
          </EnsureRoleRoute>
        )}
      />
    </Route>,

    <Route
      key="route-admin-customer"
      path="customer"
    >
      <Route
        path="report"
        element={(
          <EnsureRoleRoute roles={USER_ROLES.ADMIN_AND_SALESPERSON}>
            <CustomerReport />
          </EnsureRoleRoute>
        )}
      />
    </Route>,

    <Route
      key="route-admin-analytics"
      path="analytics"
    >
      <Route
        path="dashboard"
        element={(
          <EnsureRoleRoute roles={USER_ROLES.ADMIN_ONLY}>
            <WarehouseAnalyticsDashboard />
          </EnsureRoleRoute>
        )}
      />
      <Route
        path="ai-reports"
        element={(
          <EnsureRoleRoute roles={USER_ROLES.ADMIN_ONLY}>
            <AiReportsPage />
          </EnsureRoleRoute>
        )}
      />
    </Route>,

    <Route
      key="route-admin-invoice"
      path="invoice"
    >
      <Route
        path="list"
        element={(
          <EnsureRoleRoute roles={USER_ROLES.EXPCEPT_CUSTOMER}>
            <InvoiceList />
          </EnsureRoleRoute>
        )}
      />
      <Route
        path="detail"
        element={(
          <EnsureRoleRoute roles={USER_ROLES.ADMIN_AND_STUFF}>
            <InvoiceDetail />
          </EnsureRoleRoute>
        )}
      />
    </Route>,

    <Route
      key="route-admin-collection"
      path="collection"
    >
      <Route
        index
        element={(
          <EnsureRoleRoute roles={USER_ROLES.ADMIN_AND_STUFF}>
            <CollectionList />
          </EnsureRoleRoute>
        )}
      />
      <Route
        path="list"
        element={(
          <EnsureRoleRoute roles={USER_ROLES.ADMIN_AND_STUFF}>
            <CollectionList />
          </EnsureRoleRoute>
        )}
      />
      <Route
        path="edit"
        element={(
          <EnsureRoleRoute roles={USER_ROLES.ADMIN_AND_STUFF}>
            <CollectionEdit />
          </EnsureRoleRoute>
        )}
      />
    </Route>,

    <Route
      key="route-admin-tag"
      path="tag"
    >
      <Route
        index
        element={(
          <EnsureRoleRoute roles={USER_ROLES.ADMIN_AND_STUFF}>
            <TagList />
          </EnsureRoleRoute>
        )}
      />
      <Route
        path="list"
        element={(
          <EnsureRoleRoute roles={USER_ROLES.ADMIN_AND_STUFF}>
            <TagList />
          </EnsureRoleRoute>
        )}
      />
      <Route
        path="edit"
        element={(
          <EnsureRoleRoute roles={USER_ROLES.ADMIN_AND_STUFF}>
            <TagEdit />
          </EnsureRoleRoute>
        )}
      />
    </Route>,

    <Route
      key="route-admin-product"
      path="product"
    >
      <Route
        index
        element={(
          <EnsureRoleRoute roles={USER_ROLES.ADMIN_AND_STUFF}>
            <ProductList />
          </EnsureRoleRoute>
        )}
      />
      <Route
        path="list"
        element={(
          <EnsureRoleRoute roles={USER_ROLES.ADMIN_AND_STUFF}>
            <ProductList />
          </EnsureRoleRoute>
        )}
      />
      <Route
        path="edit"
        element={(
          <EnsureRoleRoute roles={USER_ROLES.ADMIN_AND_STUFF}>
            <ProductEdit />
          </EnsureRoleRoute>
        )}
      />
      <Route path="vendor">
        <Route
          index
          element={(
            <EnsureRoleRoute roles={USER_ROLES.ADMIN_ONLY}>
              <VendorList />
            </EnsureRoleRoute>
          )}
        />
        <Route
          path="list"
          element={(
            <EnsureRoleRoute roles={USER_ROLES.ADMIN_ONLY}>
              <VendorList />
            </EnsureRoleRoute>
          )}
        />
        <Route
          path="edit"
          element={(
            <EnsureRoleRoute roles={USER_ROLES.ADMIN_ONLY}>
              <VendorEdit />
            </EnsureRoleRoute>
          )}
        />
      </Route>
    </Route>,

    <Route
      key="route-admin-user"
      path="user"
    >
      <Route
        index
        element={(
          <EnsureRoleRoute roles={USER_ROLES.EXPCEPT_CUSTOMER}>
            <UserList />
          </EnsureRoleRoute>
        )}
      />
      <Route
        path="list"
        element={(
          <EnsureRoleRoute roles={USER_ROLES.EXPCEPT_CUSTOMER}>
            <UserList />
          </EnsureRoleRoute>
        )}
      />
      <Route
        path="edit"
        element={(
          <EnsureRoleRoute roles={USER_ROLES.EXPCEPT_CUSTOMER}>
            <UserEdit />
          </EnsureRoleRoute>
        )}
      />
      <Route
        path="detail"
        element={(
          <EnsureRoleRoute roles={USER_ROLES.EXPCEPT_CUSTOMER}>
            <UserDetail />
          </EnsureRoleRoute>
        )}
      />
    </Route>,

    <Route
      key="route-admin-receiving"
      path="receiving"
    >
      <Route
        index
        element={(
          <EnsureRoleRoute roles={USER_ROLES.ADMIN_AND_STUFF}>
            <ReceivingList />
          </EnsureRoleRoute>
        )}
      />
      <Route
        path="list"
        element={(
          <EnsureRoleRoute roles={USER_ROLES.ADMIN_AND_STUFF}>
            <ReceivingList />
          </EnsureRoleRoute>
        )}
      />
      <Route
        path="edit"
        element={(
          <EnsureRoleRoute roles={USER_ROLES.ADMIN_AND_STUFF}>
            <ReceivingEdit />
          </EnsureRoleRoute>
        )}
      />
    </Route>,

    <Route
      key="route-admin-addon-list"
      path="settings"
      element={(
        <EnsureRoleRoute roles={USER_ROLES.ADMIN_ONLY}>
          <WebsiteInfo />
        </EnsureRoleRoute>
      )}
    />,
    <Route
      key="route-admin-addon-list"
      path="contents"
      element={(
        <EnsureRoleRoute roles={USER_ROLES.ADMIN_ONLY}>
          <WebsiteContent />
        </EnsureRoleRoute>
      )}
    />,
  ]);

  bootstrap.panel = bootstrap.panel.concat([
    {
      label: 'Home',
      link: '/management/home',
      linkAlias: ['management', 'management/home'],
    },
    {
      label: 'Orders',
      children: [{
        testid: 'customer-orders',
        label: 'Customer Orders',
        link: '/management/order/list',
        linkAlias: ['order', 'management/order'],
        children: [{
          label: 'Overdue Orders',
          link: '/management/order/overdue',
          linkAlias: ['management/order/overdue'],
        }, {
          label: 'Order Reminders',
          link: '/management/order/reminders',
          linkAlias: ['management/order/reminders'],
        }],
      }, {
        testid: 'bulk-orders',
        label: 'Bulk Orders',
        link: '/management/bulk/list',
        linkAlias: ['management/bulk'],
        roles: USER_ROLES.ADMIN_AND_STUFF,
      }, {
        testid: 'inventory-orders',
        label: 'Inventory Orders',
        link: '/management/inventory/list',
        linkAlias: ['management/inventory/list'],
        roles: USER_ROLES.ADMIN_AND_STUFF,
      }],
    },
    // {
    //   label: 'Invoice',
    //   link: '/management/invoice/list',
    //   linkAlias: ['invoice', 'management/invoice'],
    // },
    {
      label: 'Collections',
      children: [{
        label: 'List',
        link: '/management/collection/list',
        linkAlias: ['management/collection/list'],
      }, {
        testid: 'collection-add',
        label: 'Add',
        link: '/management/collection/edit',
        linkAlias: ['management/collection/edit'],
      }],
      roles: USER_ROLES.ADMIN_AND_STUFF,
    },
    {
      label: 'Tags',
      children: [{
        testid: 'tag-list',
        label: 'List',
        link: '/management/tag/list',
        linkAlias: ['management/tag/list'],
      }, {
        testid: 'tag-add',
        label: 'Add',
        link: '/management/tag/edit',
        linkAlias: ['management/tag/edit'],
      }],
      roles: USER_ROLES.ADMIN_AND_STUFF,
    },
    {
      label: 'Products',
      children: [{
        testid: 'product-list',
        label: 'List',
        link: '/management/product/list',
        linkAlias: ['product', 'management/product/list'],
        roles: USER_ROLES.ADMIN_AND_STUFF,
      }, {
        testid: 'product-add',
        label: 'Add',
        link: '/management/product/edit',
        linkAlias: ['management/product/edit'],
        roles: USER_ROLES.ADMIN_AND_STUFF,
      }, {
        label: 'Vendors',
        roles: USER_ROLES.ADMIN_ONLY,
        children: [{
          testid: 'vendor-list',
          label: 'List',
          link: '/management/product/vendor/list',
          linkAlias: ['management/product/vendor/list'],
        }, {
          testid: 'vendor-add',
          label: 'Add',
          link: '/management/product/vendor/edit',
          linkAlias: ['management/product/vendor/edit'],
        }],
      }, {
        testid: 'shop-for-customer',
        label: 'Shop for Customer',
        link: '/shop',
      }, {
        testid: 'shop-for-admin',
        label: 'Shop for Admin',
        link: '/shop?inventory=true',
        roles: USER_ROLES.ADMIN_ONLY,
      }],
      roles: USER_ROLES.EXPCEPT_CUSTOMER,
    },
    {
      label: 'Receiving Management',
      children: [{
        testid: 'receiving-list',
        label: 'List',
        link: '/management/receiving/list',
        linkAlias: ['management/receiving/list'],
      }, {
        testid: 'receiving-add',
        label: 'Add',
        link: '/management/receiving/edit',
        linkAlias: ['management/receiving/edit'],
      }],
      roles: USER_ROLES.ADMIN_AND_STUFF,
    },
    {
      label: 'User Management',
      children: [{
        testid: 'user-list',
        label: 'List',
        link: '/management/user/list',
        linkAlias: ['management/user/list', 'management/user/detail'],
      }, {
        testid: 'user-add',
        label: 'Add User',
        link: '/management/user/edit',
        linkAlias: ['management/user/edit'],
      }],
    },
    {
      label: 'Warehouse Analysis',
      children: [{
        testid: 'analytics-dashboard',
        label: 'Analytics Dashboard',
        link: '/management/analytics/dashboard',
        linkAlias: ['management/analytics/dashboard'],
        roles: USER_ROLES.ADMIN_ONLY,
      }, {
        testid: 'ai-reports',
        label: 'AI Reports',
        link: '/management/analytics/ai-reports',
        linkAlias: ['management/analytics/ai-reports'],
        roles: USER_ROLES.ADMIN_ONLY,
        badge: 'exp',
        visibleWhen: (ctx) => ctx.aiReportsEnabled === true,
      }, {
        testid: 'inventory-analytics',
        label: 'Inventory Analytics',
        link: '/management/inventory/analytics',
        linkAlias: ['management/inventory/analytics'],
        roles: USER_ROLES.ADMIN_ONLY,
        badge: 'exp',
      }, {
        testid: 'inventory-report',
        label: 'Inventory Report',
        link: '/management/inventory/report',
        linkAlias: ['management/inventory/report'],
      }, {
        testid: 'inventory-sales-report',
        label: 'Sales Report',
        link: '/management/inventory/sales',
        linkAlias: ['management/inventory/sales'],
      }, {
        testid: 'customer-report',
        label: 'Customer Report',
        link: '/management/customer/report',
        linkAlias: ['management/customer/report'],
        roles: USER_ROLES.ADMIN_AND_SALESPERSON,
      }],
    },
    {
      label: 'Website Management',
      children: [{
        label: 'Content',
        link: '/management/contents',
        linkAlias: ['management/contents'],
      }, {
        label: 'Settings',
        link: '/management/settings',
        linkAlias: ['management/settings'],
        roles: USER_ROLES.ADMIN_ONLY,
      }, {
        label: 'API Keys',
        link: '/management/api-access/list',
        linkAlias: ['management/api-access'],
        roles: USER_ROLES.ADMIN_ONLY,
        badge: 'exp',
      }],
      roles: USER_ROLES.ADMIN_ONLY,
    },
  ]);
}

function Description() {
  return (
    <>
      <div>
        The <b>SWM</b> (S)mall (W)arehouse (M)anagement <b>Basic Plan</b> provides below key features for running your businesses smoothly:
      </div>
      <div>
        <ul>
          <li>3 different <b>User Roles</b>: Customers, Staff, Admin.</li>
          <li>3 Different Types of <b>Orders Creation</b>: Customer orders, Inventory orders, Bulk orders.</li>
          <li>3 Different Types of <b>Email Notifications</b>: Order placing conformation, Order updates conformation, Order cancellation confirmation.</li>
          <li>2 different Types of <b>Warehouse Inventory Managements</b>: In-Stock inventories, In-Production inventories.</li>
          <li>2 different Types of <b>Warehouse Receiving Managements</b>: Barcode scanning receiving, On-page receiving.</li>
          <li>2 different Types of <b>Warehouse Analysis Reports</b>: Inventory report, Inventory Sales report.</li>
          <li>All Types of <b>Orders Exporting</b>.</li>
        </ul>
      </div>
    </>
  );
}

const info = {
  id: ADDONS.ESSENTIAL,
  available: true,
  name: 'SWM Basic',
  version: '1.0',
  icon,
  descriptionText: 'SWM, The (S)mall (W)arehouse (M)anagement service, was specially designed and implemented for fulfilling the special needs for small warehouse managing purposes. Compared to the other general warehouse management platforms, the SWM provides a much smoother managing experience and unrivaled versatilities for running your businesses.',
  descriptionComponent: <Description />,
  priceModel: PRICE_MODEL.CONTINUES_SUBSCRIPTION,
  prices: [{
    price: 500,
    cycle: BILLING_CYCLE.MONTHLY,
  }, {
    price: '6,000',
    cycle: BILLING_CYCLE.ANNUALLY,
  }],
};

const addon: Addon = {
  apply,
  info,
};

export default addon;
